/**
 * Normalizes telephone input toward E.164-style storage: an optional leading `+`
 * and up to 15 digits (ITU-T E.164 maximum). Non-digit characters are removed.
 * If the value contains `+`, all digits in the string are collected and prefixed
 * with `+`. Otherwise only digits are kept (no `+`).
 */
export function normalizeE164TelInput(value: string): string {
  const trimmed = value.trim();
  if (trimmed === "") {
    return "";
  }

  if (trimmed.includes("+")) {
    const digits = trimmed.replace(/\D/g, "");
    return `+${digits.slice(0, 15)}`;
  }

  return trimmed.replace(/\D/g, "").slice(0, 15);
}
